module.exports = __webpack_public_path__ + "img/card-event-01.6effe109.svg";